import React, { useState } from "react";
import classNames from "classnames";
import MultiSelect from "react-multi-select-component";

import "./SelectInput.scss";
import { normalizeSelectInputValue } from "./SelectInput.utils";
import SelectInputOption from "./SelectInputOption";
import useSelectInputOutsideClose, {
  closeSelectInputMenu
} from "./useSelectInputOutsideClose";

const SelectInput = ({
  label,
  options,
  value,
  onChange,
  isMulti = true,
  hasSelectAll = false,
  disableSearch = true,
  overrideStrings,
  disabled,
  isRequired = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useSelectInputOutsideClose(isOpen);
  const selectedValue = Array.isArray(value) ? value : [];
  const active = isOpen || selectedValue.length > 0;

  return (
    <div className="lp_select-input-wrapper" ref={wrapperRef}>
      <div
        className={classNames(
          "lp_select-input relative rounded bg-white p-1 m-0 border-solid border-1 block",
          {
            "border-gray": true,
            "lp_select-input_active": active,
            "lp_select-input_focused": isOpen,
            "lp_select-input_disabled": disabled
          }
        )}
      >
        <span
          className={classNames(
            "absolute block lp_select-input_label px-2",
            {
              "text-black-9 text-xs.1 lp_select-input_label_active": active,
              "text-black text-sm": !active
            }
          )}
        >
          {isRequired ? `${label} *` : label}
        </span>
        <MultiSelect
          options={options}
          value={selectedValue}
          onChange={nextValue => {
            onChange(normalizeSelectInputValue(nextValue, isMulti));

            if (!isMulti) {
              closeSelectInputMenu(wrapperRef.current);
              setIsOpen(false);
            }
          }}
          labelledBy={label}
          hasSelectAll={hasSelectAll}
          disableSearch={disableSearch}
          disabled={disabled}
          onMenuToggle={setIsOpen}
          overrideStrings={overrideStrings}
          ItemRenderer={SelectInputOption}
        />
        <span className="lp_select-input_arrow" />
      </div>
    </div>
  );
};

export default SelectInput;
